import { type ISbRichtext } from '@storyblok/react'
import { type RichtextStoryblok } from '~/types/generated'
import { type RichTextProps } from './RichText.interface'

export const mapRichText = (blok: RichtextStoryblok): RichTextProps => ({
  richtext: blok.richtext as ISbRichtext
})
